import { Link } from 'react-router-dom';
import { LegalPage, LegalSection, MailLink } from '../components/LegalPage';
import { BUSINESS, businessAddressInline } from '../lib/business';
import { useSiteContent } from '../hooks/useSiteContent';

export default function Terms() {
  const { content: contacts } = useSiteContent('site.contacts');
  return (
    <LegalPage
      title="Condizioni Generali di Vendita"
      description="Condizioni generali di vendita dei prodotti Apicoltura DePiccoli acquistati online."
      lastUpdated="3 ottobre 2026"
    >
      <LegalSection title="1. Venditore">
        <p>
          Le presenti condizioni regolano la vendita a distanza dei prodotti offerti sul sito
          apicolturadepiccoli.it da:
        </p>
        <p>
          <strong>{BUSINESS.legalName}</strong>
          <br />
          Sede: {businessAddressInline}
          <br />
          P.IVA: {BUSINESS.vatNumber}
          <br />
          Email: <MailLink email={contacts.email} />
          {contacts.phone && (
            <>
              <br />
              Telefono: {contacts.phone}
            </>
          )}
        </p>
      </LegalSection>

      <LegalSection title="2. Ambito di applicazione">
        <p>
          Le condizioni si applicano agli acquisti effettuati sul sito da consumatori, cioè persone
          fisiche che agiscono per scopi estranei all'attività imprenditoriale o professionale
          eventualmente svolta, ai sensi del D.Lgs. 206/2005 (Codice del Consumo). Inviando un
          ordine il cliente dichiara di averle lette e accettate. Le condizioni applicate sono
          quelle pubblicate al momento dell'ordine.
        </p>
      </LegalSection>

      <LegalSection title="3. Prodotti e prezzi">
        <p>
          I prodotti sono descritti nelle rispettive schede. Le immagini sono indicative: trattandosi
          di un prodotto naturale, colore e consistenza del miele possono variare tra un lotto e
          l'altro e il miele può cristallizzare, senza che questo ne alteri la qualità.
        </p>
        <p>
          Tutti i prezzi sono espressi in euro e comprensivi di IVA. Le spese di spedizione sono
          indicate separatamente nel carrello prima della conferma dell'ordine e descritte nella
          pagina{' '}
          <Link to="/spedizioni" className="text-primary hover:underline">
            Spedizioni
          </Link>
          .
        </p>
      </LegalSection>

      <LegalSection title="4. Conclusione del contratto">
        <p>
          Il contratto si conclude quando il pagamento viene autorizzato e il cliente riceve
          l'email di conferma dell'ordine, che riepiloga prodotti, prezzi e spese di spedizione.
          Il cliente è tenuto a verificare la correttezza dei dati inseriti e a segnalare
          tempestivamente eventuali errori.
        </p>
        <p>
          Se dopo il pagamento un prodotto risultasse non disponibile, il cliente sarà avvisato via
          email e rimborsato dell'importo corrispondente entro 14 giorni.
        </p>
      </LegalSection>

      <LegalSection title="5. Pagamento">
        <p>
          Il pagamento avviene con carta di credito o di debito tramite Stripe, al momento
          dell'ordine. I dati della carta sono gestiti direttamente da Stripe e non vengono mai
          memorizzati sui nostri sistemi.
        </p>
      </LegalSection>

      <LegalSection title="6. Consegna">
        <p>
          Le spedizioni sono effettuate solo in Italia. Metodi, costi e tempi di consegna sono
          indicati nella pagina{' '}
          <Link to="/spedizioni" className="text-primary hover:underline">
            Spedizioni
          </Link>
          . I tempi sono indicativi; in ogni caso la consegna avviene entro 30 giorni dalla
          conclusione del contratto, come previsto dall'art. 61 del Codice del Consumo.
        </p>
        <p>
          Al ricevimento il cliente è invitato a controllare l'integrità del pacco e a segnalare
          eventuali danni dovuti al trasporto entro 7 giorni, allegando se possibile una foto.
        </p>
      </LegalSection>

      <LegalSection title="7. Diritto di recesso">
        <p>
          Il cliente consumatore può recedere dal contratto entro 14 giorni dalla consegna, senza
          dover fornire alcuna motivazione, con le modalità e le eccezioni indicate nella pagina{' '}
          <Link to="/resi" className="text-primary hover:underline">
            Diritto di recesso e resi
          </Link>
          .
        </p>
      </LegalSection>

      <LegalSection title="8. Garanzia legale di conformità">
        <p>
          Tutti i prodotti sono coperti dalla garanzia legale di conformità prevista dagli artt.
          128 e seguenti del Codice del Consumo. In caso di prodotto non conforme (ad esempio
          vasetto rotto, prodotto diverso da quello ordinato o alterato) il cliente può scriverci
          a <MailLink email={contacts.email} /> e ha diritto, senza spese, alla sostituzione del
          prodotto o, se non possibile, alla riduzione del prezzo o al rimborso.
        </p>
      </LegalSection>

      <LegalSection title="9. Dati personali">
        <p>
          I dati forniti con l'ordine sono trattati secondo quanto descritto nella{' '}
          <Link to="/privacy" className="text-primary hover:underline">
            Privacy Policy
          </Link>
          .
        </p>
      </LegalSection>

      <LegalSection title="10. Reclami e risoluzione delle controversie">
        <p>
          Per qualsiasi reclamo il cliente può scrivere a <MailLink email={contacts.email} />:
          rispondiamo entro 7 giorni lavorativi. Il consumatore può inoltre ricorrere alle
          procedure di risoluzione alternativa delle controversie (ADR) previste dagli artt. 141 e
          seguenti del Codice del Consumo.
        </p>
      </LegalSection>

      <LegalSection title="11. Legge applicabile e foro competente">
        <p>
          Il contratto è regolato dalla legge italiana. Per le controversie con il consumatore è
          competente il giudice del luogo di residenza o domicilio del consumatore, ai sensi
          dell'art. 66-bis del Codice del Consumo.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
